export const SET_REQUEST_OFFER_DATA = 'SET_REQUEST_OFFER_DATA';